export const DEFAULT_SHIPMENT_STATUSES: ShipmentStatusValue[] = [
  "ACTIVE",
  "BOOKED",
  "PICKED_UP",
];
export const DEFAULT_SUPPLIER_SHIPMENT_STATUSES: ShipmentStatusValue[] = [
  "BOOKED",
  "PICKED_UP",
  "DELIVERED",
];
export const DEFAULT_CARRIER_SHIPMENT_STATUSES: ShipmentStatusValue[] = [
  "ACTIVE",
];
